module.exports = {
  "CPU Load": "CPU负载",
  "RAM Load": "内存负载",
  "CPU Temperature": "CPU温度",
  "Storage Usage": "存储使用情況",
  "Device Offline Monitor": "设备离线监控",
  "App Crash Detection": "应用崩溃检测",
  "Peripheral Monitor": "外设监控",
  "+UT6Us": "津巴布韦",
  "+cSl6d": "荷兰",
  "+vx0UI": "所罗门群岛",
  "+vz4Gy": "塞拉利昂",
  "/1g/gd": "基里巴斯",
  "/EzG+0": "蒙特塞拉特",
  "/ZaEbq": "海地",
  "07BMT/": "阿尔及利亚",
  "0E6+/f": "关岛",
  "14axoc": "福克兰群岛",
  "1BFTBO": "古巴",
  "1GLoiG": "格鲁吉亚",
  "1Z3cpQ": "象牙海岸",
  "1qc1Bb": "拉脱维亚",
  "217kis": "卢旺达",
  "2c/STs": "摩尔多瓦",
  "3B2kCX": "法罗群岛",
  "3Nlsp9": "斯洛伐克",
  "3a17nf": "库克群岛",
  "41lx/9": "阿富汗",
  "4KMP9f": "刚果",
  "4obEtL": "多哥",
  "5w+tOJ": "阿尔巴尼亚",
  "62Z8c1": "帕劳",
  "6JR/Y7": "爱尔兰",
  "6LZPqX": "萨摩亚",
  "6Mnz8p": "毛里塔尼亚",
  "6NPwCy": "叙利亚",
  "6f8kym": "伊拉克",
  "6qdPnx": "突尼斯",
  "7KZ6vz": "委内瑞拉",
  "7hGupC": "立陶宛",
  "7hNQVL": "菲律宾",
  "7p85Tc": "库拉索",
  "8m5tda": "埃及",
  "8y7qAE": "中非共和国",
  "98qFTO": "泽西",
  "99fbLn": "乌拉圭",
  "9T1JPo": "马耳他",
  AD5RPE: "赤道几内亚",
  AKnToQ: "乍得",
  "AO/9GT": "芬兰",
  AYs4yh: "马达加斯加",
  Ai6HyC: "乌干达",
  AksTq6: "安提瓜和巴布达",
  ArbweL: "约旦",
  AzRGCX: "德国",
  "B/oRh5": "密克罗尼西亚联邦",
  BcJbbP: "卡塔尔",
  Bm5GdP: "中国台湾",
  MRbe2A: "中国台湾",
  BwMY6I: "西撒哈拉",
  BxT2qw: "托克劳",
  C0YR5J: "土库曼斯坦",
  C2pikc: "苏丹南部",
  C7RUR5: "瑙鲁",
  CKu8W1: "纽埃",
  CYSGlA: "爱沙尼亚",
  "D/Hl19": "马提尼克岛",
  DPthJ5: "卢森堡",
  Dxf50E: "科摩罗",
  EMaGPN: "索马里的",
  "Eihfz+": "巴基斯坦",
  Eul4yJ: "意大利",
  F0BTvX: "留尼汪",
  FsQ2Ph: "北马里亚纳群岛",
  FzXhJn: "罗马教廷(梵蒂冈城市国家)",
  GRDGdf: "新喀里多尼亚",
  "HF/NiY": "亚美尼亚",
  HN9EHr: "韩国",
  HTqMY5: "罗马尼亚",
  HZs8KL: "布基纳法索",
  I2RkrK: "柬埔寨",
  I7Erl3: "摩洛哥",
  IGBRed: "阿塞拜疆",
  IPfyBg: "伊朗",
  IbG9YJ: "诺福克岛",
  "IrME/4": "中国澳门",
  XeQT0P: "中国澳门",
  J1oSvz: "属维尔京群岛、美国",
  JIPBj1: "牙买加",
  JIWrkV: "加拿大",
  JJhl02: "刚果民主共和国",
  JOJTuh: "哥斯达黎加",
  JddSbX: "多米尼克",
  L7PjzJ: "圣诞岛",
  LShUE0: "不丹",
  "Le+IiI": "北的马其顿",
  LeMbDw: "赞比亚",
  LfkgD6: "澳大利亚",
  Lszars: "美国",
  M16xFB: "文莱",
  MMzrYK: "列支敦士登",
  MTVChl: "汤加",
  MXueJK: "安道尔",
  MYneOz: "吉布提",
  MZwu6r: "赫德岛和麦克唐纳群岛",
  MbV1M9: "马来西亚",
  MkBrsn: "巴拉圭",
  MwNlM3: "布隆迪",
  MyB1Vf: "沙特阿拉伯",
  NcwUGt: "以色列",
  OZFYbQ: "瓦努阿图",
  OZyB9b: "波斯尼亚和黑塞哥维那的",
  Oc4oig: "玻利维亚",
  OhEAqA: "希腊",
  Oql6Jb: "葡萄牙",
  PB00mS: "瓦利斯群岛和富图纳群岛",
  PBGuz3: "波兰",
  PIBLYF: "中国香港",
  "1ObLsW": "中国香港",
  PIHPBR: "法属圣马丁",
  PjOc8o: "白俄罗斯",
  "Q+FGAs": "冰岛",
  "Q5QY0+": "开曼群岛",
  Q5U8nY: "美属萨摩亚",
  QA9U89: "英属印度洋领土",
  QRUdeg: "墨西哥",
  QxRaqi: "丹麦",
  RfQSLo: "北朝鲜",
  RlB4rB: "南乔治亚岛和南桑威奇群岛",
  RsWzOr: "匈牙利",
  RzKiE0: "波多黎各",
  SEJjjI: "南极洲",
  SLmrMX: "保加利亚",
  T6qzNm: "老挝",
  Tb6AtC: "阿拉伯联合酋长国",
  To4yI6: "冈比亚",
  TqXGpl: "伯利兹",
  UQHsPm: "佛得角",
  UZmEHG: "蒙古",
  Ulf4Sq: "印度",
  VCRq6v: "皮特凯恩",
  VIFtwp: "喀麦隆",
  VTEHKS: "几内亚比绍",
  VWg1hF: "斯瓦尔巴特群岛和扬马延岛",
  VhGXkw: "奥兰群岛",
  W2fcGi: "苏里南",
  W9gKgU: "塞舌尔",
  WAl9tj: "东帝汶",
  "WH+mo5": "乌兹别克斯坦",
  WJAfY4: "图瓦卢",
  WobBPP: "利比里亚",
  XfoqmV: "萨尔瓦多",
  XoOuKT: "哈萨克斯坦",
  YINkHp: "塞尔维亚",
  YMjT8q: "新加坡",
  "Z+fptr": "哥伦比亚",
  ZHe4St: "印度尼西亚",
  ZRhaI4: "巴巴多斯",
  ZgLO7j: "黎巴嫩",
  a9nZYf: "布维岛",
  aNVBIV: "法国",
  afgUkt: "特立尼达和多巴哥",
  ahaefV: "中国",
  b8Yur0: "贝宁",
  bCl9eg: "越南",
  bKHwtk: "孟加拉国",
  bQkGVT: "俄罗斯联邦",
  "cio5m/": "新西兰",
  "d+SgS7": "尼加拉瓜",
  d97FOT: "巴布亚新几内亚",
  dUeWgE: "斐济群岛",
  dXFo2O: "挪威",
  dcfcTW: "圣皮埃尔和密克隆群岛",
  dyBAW0: "塞内加尔",
  eNa9WG: "圣赫勒拿的",
  eX9WT0: "圣马力诺",
  eiecNW: "莱索托",
  eu7j6G: "黑山",
  f6i4Ch: "多米尼加共和国",
  fSGNZz: "比利时",
  fe4fox: "苏丹",
  fp4MWN: "日本",
  g44w8D: "联合王国",
  gIZauu: "危地马拉",
  gb8v87: "土耳其",
  h70zPD: "西班牙",
  hB6jsF: "塞浦路斯",
  hBpMeF: "马绍尔群岛",
  hC0etv: "智利",
  hLeEYi: "圣文森特和格林纳丁斯",
  hrmyDn: "坦桑尼亚",
  htLGF6: "博内尔岛",
  htNRZG: "摩纳哥",
  hy4yn7: "吉尔吉斯斯坦",
  iJsE6u: "马里",
  iVyVIA: "根西岛",
  iYdC7o: "尼泊尔",
  icfTwL: "斯里兰卡",
  icoYQF: "法国南部的领土",
  ipoOkJ: "尼日尔",
  j2GbDK: "圣多美和普林西比",
  "j83TV+": "马恩岛",
  jHmcI7: "几内亚",
  jKdq05: "阿鲁巴",
  "jZLo+u": "也门",
  kCwSgm: "瑞典",
  lAVHXj: "加蓬",
  lc0eVA: "圣巴泰勒米",
  ljBSDy: "巴林",
  mIgnTu: "百慕大",
  mdbt1h: "格林纳达",
  n1eYYR: "克罗地亚",
  n6sdJi: "尼日利亚",
  nU0AoJ: "毛里求斯",
  nbVGOe: "圭亚那",
  ncprFv: "巴勒斯坦",
  nfMTZ9: "阿拉伯利比亚民众国",
  "oC/YmL": "安哥拉",
  oJA0AV: "乌克兰",
  ofe1Jv: "斯洛文尼亚",
  ox0SUk: "厄立特里亚",
  pG9dnN: "法属圭亚那",
  pGsPfz: "塔吉克斯坦",
  "prG89+": "荷属圣马丁",
  "qKL/I7": "厄瓜多尔",
  qhRoDt: "捷克共和国",
  r0r576: "奥地利",
  riK5Od: "马约特岛",
  "s/ZbGB": "直布罗陀",
  sVaevR: "法属波利尼西亚",
  sgg3ZA: "肯尼亚",
  srKhxN: "巴哈马",
  ssKHGM: "格陵兰",
  swmjZg: "泰国",
  "tUisY+": "加纳",
  u3ws3s: "南非",
  u9cEKj: "圣基茨和尼维斯",
  uPO36O: "缅甸",
  uY8iM9: "莫桑比克",
  ufZlit: "巴拿马",
  ufyzs9: "圣卢西亚",
  v8IwQb: "阿根廷",
  vPS1uD: "秘鲁",
  vTEjni: "马拉维",
  vcSBZu: "巴西",
  vixhhG: "马尔代夫",
  "wL/u2o": "特克斯和凯科斯群岛",
  "wYCJ++": "斯威士兰",
  "we/YPm": "阿曼",
  xFrFSm: "纳米比亚",
  xV0lln: "属维尔京群岛、英国",
  xepQSL: "科科斯(基灵)群岛",
  xk4ByO: "瓜德罗普岛",
  xwICWz: "瑞士",
  yC4n0v: "科威特",
  yKWAek: "安圭拉",
  yLlbwi: "博茨瓦纳",
  zhs13i: "洪都拉斯",
  zw39MM: "埃塞俄比亚",
  "+31PFz": "亚洲/乌鲁木齐",
  "+6yBji": "亚洲/曼谷",
  "+CgfU2": "太平洋/埃法特",
  "+POdLR": "欧洲/伏尔加格勒",
  "+VqRkg": "美洲/肯塔基/蒙蒂塞洛",
  "/+Dhy+": "美洲/圣保罗",
  "/D9zXZ": "大西洋/雷克雅未克",
  "/UGQnF": "美洲/诺姆",
  "0DYv/B": "非洲/内罗毕",
  "0HnaGc": "太平洋/夸贾林",
  "0R8CQs": "欧洲/布达佩斯",
  "0xV9JO": "美洲/阿根廷/拉里奥哈",
  "1H4FmE": "欧洲/乌日哥罗德",
  "1mv3LM": "亚洲/赤塔",
  "1pl9Su": "非洲/的黎波里",
  "1sEPCz": "亚洲/东京",
  "1ua619": "欧洲/布拉格",
  "23aBJh": "美洲/丹佛",
  "2DXZtH": "欧洲/哥本哈根",
  "2OWj6s": "亚洲/贝鲁特",
  "2WXSh8": "亚洲/卡拉奇",
  "2qYhi8": "亚洲/香港",
  "2s/Mlc": "亚洲/堪察加",
  "2zQAXL": "欧洲/基希讷乌",
  "327IN3": "美洲/亚库塔特",
  "339CIL": "美洲/伯利兹",
  "3Lz3cq": "太平洋/恩德伯里",
  "40b51E": "美洲/密克隆",
  "4AZ4gQ": "美洲/阿根廷/萨尔塔",
  "4D94K+": "南极洲/凯西",
  "4NXksL": "欧洲/里斯本",
  "4XF+Io": "美洲/特古西加尔巴",
  "4l3qM7": "太平洋/努美阿",
  "4neOsl": "美洲/丹马沙文",
  "4wb1r/": "欧洲/卢森堡",
  "5M8Wkq": "美洲/阿根廷/胡胡伊",
  "5oeyFi": "美洲/阿根廷/里奥加耶戈斯",
  "5xwaJJ": "太平洋/富纳富提",
  "6/dk2l": "欧洲/辛菲罗波尔",
  "6Rz5js": "非洲/阿尤恩",
  "6XgRmz": "亚洲/科布多",
  "6d5tvh": "美洲/博阿维斯塔",
  "6wYqzG": "太平洋/威克",
  "71fHGN": "美洲/圭亚那",
  "7Q7WxK": "美洲/危地马拉",
  "7WBtG1": "太平洋/马朱罗",
  "7euHXg": "太平洋/布干维尔",
  "7jiQ+M": "亚洲/台北",
  "82GEmf": "太平洋/瑙鲁",
  "8DjTJi": "太平洋/法考福",
  "9Fhwtp": "非洲/蒙罗维亚",
  "9TfEAv": "亚洲/达卡",
  "9UC6g0": "亚洲/澳门",
  "9xN38t": "亚洲/利雅得",
  A1qgI0: "美洲/大坎普",
  A8Tpo2: "非洲/开罗",
  ADtcg9: "美洲/印第安纳/彼得斯堡",
  AQnn4z: "亚洲/卡塔尔",
  AX2M6K: "非洲/卡萨布兰卡",
  ApEhaf: "南极洲/东方站",
  "BsRS+L": "非洲/拉各斯",
  "CIpc+3": "亚洲/仰光",
  CJgAlM: "美洲/阿根廷/布宜诺斯艾利斯",
  CMi686: "欧洲/萨马拉",
  CRI2Ve: "太平洋/查塔姆",
  CezJKN: "美洲/圣地亚哥",
  "Cs/zIo": "太平洋/马克萨斯",
  CvKLCn: "太平洋/汤加塔布",
  CwyqPj: "非洲/阿克拉",
  D1tmTQ: "美洲/北达科他/中心",
  D55vg4: "非洲/突尼斯",
  DAlYN5: "欧洲/伊斯坦布尔",
  DCrzIX: "欧洲/安道尔",
  DDqHds: "非洲/喀土穆",
  DQsykN: "美洲/哈瓦那",
  DVZRDC: "欧洲/奥斯陆",
  DcYI27: "非洲/马普托",
  "EGDZo+": "亚洲/中科雷姆斯克",
  EcRGq9: "亚洲/迪拜",
  EgIxeE: "美洲/牙买加",
  "EnTK+r": "美洲/芝加哥",
  EqvKbF: "美洲/库亚巴",
  F0y8e9: "美洲/洛杉矶",
  F465cE: "欧洲/赫尔辛基",
  F6OWRn: "太平洋/莫尔兹比港",
  FDGDXD: "欧洲/基辅",
  FEnpn4: "欧洲/柏林",
  FeFqOa: "亚洲/乔巴山",
  "G0/1QH": "美洲/帕拉马里博",
  "GHrEk+": "亚洲/胡志明市",
  Gcuin4: "亚洲/乌兰巴托",
  "H+kwCw": "亚洲/文莱",
  "H/TECz": "亚洲/首尔",
  H11GhT: "亚洲/坎德加",
  HD7dNh: "亚洲/克孜勒奥尔达",
  HDlqGj: "美洲/阿根廷/图库曼",
  HSmzBV: "美洲/阿根廷/圣路易斯",
  I2fe6r: "亚洲/希伯伦",
  ID5HGa: "太平洋/关岛",
  "IRsI+H": "亚洲/望加锡",
  IVs8gT: "印度洋/毛里求斯",
  "IYKKU/": "亚洲/埃里温",
  IYSP57: "美洲/圣塔伦",
  JGg252: "亚洲/帝力",
  "JJJ+wW": "太平洋/瓦利斯",
  JTTFhT: "太平洋/科斯雷",
  KBQ98i: "欧洲/索非亚",
  L6RwvT: "美洲/斯科斯比松",
  LFkBwb: "亚洲/吉隆坡",
  LGJGKo: "美洲/印第安纳/威纳马克",
  LepYst: "美洲/阿根廷/圣胡安",
  LrC3cb: "非洲/约翰内斯堡",
  M74J18: "太平洋/阿皮亚",
  "MS/dmQ": "欧洲/维尔纽斯",
  MYvQtB: "太平洋/波纳佩",
  MhFcna: "亚洲/阿克套",
  MpIqyW: "亚洲/新西伯利亚",
  "N69J/J": "美洲/开曼群岛",
  N7RBEQ: "欧洲/巴黎",
  "NLL9E/": "亚洲/新加坡",
  Nap8NB: "美洲/拉巴斯",
  NhLpaB: "亚洲/加沙",
  NwiC8y: "亚洲/巴库",
  OPz5aV: "欧洲/华沙",
  "OSP/DU": "美洲/阿拉瓜伊纳",
  "OoH/k4": "欧洲/马耳他",
  OqlGXK: "大西洋/法罗",
  OtFyGC: "欧洲/扎波罗热",
  P9EyMh: "亚洲/阿拉木图",
  PRo9ZX: "美洲/大特克",
  Pbr43k: "太平洋/甘比尔",
  PdnZvE: "美洲/印第安纳/诺克斯",
  Phhnuu: "太平洋/瓜达尔卡纳尔",
  "PlA+93": "美洲/安克雷奇",
  "Q+QFi7": "美洲/巴拿马",
  Q0Nwql: "美洲/拿骚",
  Q2hC7E: "亚洲/阿纳德尔",
  RTFf0R: "亚洲/塔什干",
  RVtTvI: "美洲/波哥大",
  RcUwWS: "欧洲/地拉那",
  Rfu8ru: "美洲/朱诺",
  RzRPhx: "亚洲/德黑兰",
  SRDvbw: "印度洋/圣诞岛",
  SkSGFq: "美洲/亚松森",
  SqYr66: "太平洋/丘克",
  T7X3nR: "美洲/哥斯达黎加",
  TnMEvg: "欧洲/里加",
  TnQgWT: "印度洋/科科斯",
  UE61nU: "亚洲/雅加达",
  UEbt0M: "欧洲/雅典",
  UjOTtz: "欧洲/摩纳哥",
  VlcnXa: "大西洋/亚速尔",
  WICb5K: "亚洲/马加丹",
  "WJ+FQF": "亚洲/第比利斯",
  WTSjw5: "太平洋/帕果帕果",
  WUi6ng: "亚洲/古晋",
  WX1P13: "南极洲/戴维斯",
  Wb2LCw: "南极洲/罗瑟拉",
  Wg0kce: "美洲/印第安纳/文森斯",
  WhpVLY: "美洲/瓜亚基尔",
  Wq4Z0k: "美洲/贝伦",
  XK8hFK: "美洲/里奥布兰科",
  XLgiC3: "太平洋/诺福克",
  XN4sjj: "亚洲/撒马尔罕",
  XuXXK5: "美洲/累西腓",
  YOJC0Y: "美洲/印第安纳/马伦戈",
  Yux40Y: "南极洲/帕尔默",
  "Z+d4VE": "欧洲/阿姆斯特丹",
  ZOXOj5: "南极洲/莫森",
  "aKg/xg": "南极洲/特罗尔",
  "aqHEW/": "非洲/阿尔及尔",
  aqZ1dw: "太平洋/加拉帕戈斯",
  aylTTV: "美洲/库拉索",
  "b5+eh2": "亚洲/巴格达",
  b5GT3E: "非洲/比绍",
  bf8oMi: "太平洋/圣诞岛",
  bkKBAQ: "亚洲/坤甸",
  c5lOtj: "亚洲/符拉迪沃斯托克",
  cCvy0S: "美洲/加拉加斯",
  ciyA6X: "亚洲/马尼拉",
  cl18LV: "亚洲/乌斯季涅拉",
  d6W7pe: "欧洲/莫斯科",
  dw9A9j: "美洲/阿根廷/门多萨",
  e77Cv2: "亚洲/雅库茨克",
  e88zL2: "亚洲/尼科西亚",
  eDz3Tw: "美洲/阿达克",
  eJqVsD: "欧洲/直布罗陀",
  "eR7v+R": "美洲/北达科他/比尤拉",
  ekhdTj: "亚洲/查亚普拉",
  "f6G4/S": "太平洋/奥克兰",
  f6r66H: "美洲/梅诺米尼",
  fJpD6E: "非洲/恩贾梅纳",
  fqXfBN: "欧洲/罗马",
  "fxAR+x": "亚洲/乌拉尔",
  g2HLMh: "南极洲/昭和",
  gU3Odo: "美洲/纽约",
  "gibo/e": "欧洲/维也纳",
  gln1VX: "美洲/萨尔瓦多",
  guiUEK: "欧洲/布加勒斯特",
  gycX1L: "美洲/费尔南多-迪诺罗尼亚",
  h5YZ1i: "欧洲/布鲁塞尔",
  hI5EVU: "印度洋/留尼汪",
  hKq7PN: "欧洲/加里宁格勒",
  hL3apR: "美洲/利马",
  hZiOxa: "美洲/波多黎各",
  hdgzx5: "太平洋/复活节岛",
  hrq9xi: "欧洲/明斯克",
  iBXv4d: "美洲/梅特拉卡特拉",
  inPmEU: "欧洲/塔林",
  jRwF7m: "美洲/菲尼克斯",
  jaNloj: "美洲/马塞约",
  jtTALf: "太平洋/火奴鲁鲁",
  k6R7DN: "美洲/福塔雷萨",
  kLf0tS: "美洲/底特律",
  lAz3SQ: "亚洲/比什凯克",
  lNijTx: "大西洋/斯坦利",
  m5vKwe: "亚洲/加尔各答",
  mXs7zw: "美洲/锡特卡",
  mnvAEu: "美洲/印第安纳/泰尔城",
  n8UW9y: "亚洲/叶卡捷琳堡",
  nYFNxR: "亚洲/库页岛",
  o5Rywj: "美洲/阿根廷/卡塔马卡",
  oYmVJJ: "亚洲/克拉斯诺亚尔斯克",
  ocqIaV: "印度洋/查戈斯",
  ocqwXs: "亚洲/鄂木斯克",
  okHgMB: "亚洲/杜尚别",
  pKp9LP: "美洲/印第安纳/韦维",
  pNrCwc: "美洲/马瑙斯",
  pQ5zcx: "美洲/阿根廷/乌斯怀亚",
  pcGYLU: "美洲/图勒",
  pvDJax: "美洲/巴巴多斯",
  "q5++81": "欧洲/伦敦",
  q7mJWt: "美洲/博伊西",
  "qSxe/X": "欧洲/苏黎世",
  rB9Ewl: "亚洲/阿克托别",
  rIY0ZR: "印度洋/马尔代夫",
  rZTr8Y: "美洲/印第安纳/印第安纳波利斯",
  rhN321: "美洲/戈特霍布",
  rslOL6: "太平洋/塔拉瓦",
  rwZktH: "美洲/阿根廷/科尔多瓦",
  s2obSj: "太平洋/帕劳",
  s3GZlv: "美洲/西班牙港",
  slYOe6: "美洲/卡宴",
  szkWWk: "美洲/巴伊亚",
  t5CPbZ: "欧洲/都柏林",
  tHE78L: "美洲/圣多明各",
  tMDDnr: "美洲/马那瓜",
  tUaF1F: "太平洋/纽埃",
  tlkIG3: "太平洋/斐济",
  "tw/bjJ": "亚洲/新库兹涅茨克",
  u0TM9W: "美洲/太子港",
  uMXTTe: "欧洲/斯德哥尔摩",
  uNiOLq: "亚洲/耶路撒冷",
  "uOkO/r": "亚洲/伊尔库茨克",
  "utbU0+": "亚洲/阿什哈巴德",
  ux1XM2: "大西洋/百慕大",
  "v+arTX": "美洲/埃鲁内佩",
  vMATTy: "亚洲/大马士革",
  "vWWiU+": "亚洲/平壤",
  vbHpIo: "非洲/温得和克",
  vn9nKr: "美洲/波多韦柳",
  vohVUs: "亚洲/喀布尔",
  vwtvCc: "大西洋/佛得角",
  vy4zY8: "亚洲/科伦坡",
  w7kHCL: "大西洋/马德拉",
  wDFHDz: "美洲/马提尼克",
  "wbQai/": "大西洋/南乔治亚",
  wrZg4b: "亚洲/廷布",
  xAcBeP: "太平洋/塔希提岛",
  xKA8d6: "南极洲/杜蒙迪维尔",
  "xx+5iB": "美洲/肯塔基/路易斯维尔",
  y79PlA: "亚洲/安曼",
  yaBGO1: "太平洋/皮特凯恩",
  yeltlL: "印度洋/马埃岛",
  ygabsP: "美洲/北达科他/新塞勒姆",
  z6KEn9: "太平洋/拉罗汤加",
  z98zna: "印度洋/凯尔盖朗",
  zWABd8: "欧洲/贝尔格莱德",
  zm3ZI2: "亚洲/上海",
  zwjmMl: "亚洲/加德满都",
  "e5x+i6": "澳大利亚/洛德豪",
  gAtxKw: "南极洲/麦夸里",
  P5aTR8: "澳大利亚/霍巴特",
  "nFhe/c": "澳大利亚/柯里",
  e6YJm8: "澳大利亚/墨尔本",
  dmcxmV: "澳大利亚/悉尼",
  jFnCUr: "澳大利亚/布罗肯希尔",
  i5MwAy: "澳大利亚/布里斯班",
  WyjEwT: "澳大利亚/林德曼",
  JuasJd: "澳大利亚/阿德莱德",
  co8c88: "澳大利亚/达尔文",
  qm4oIk: "澳大利亚/珀斯",
  "0LrMZs": "澳大利亚/尤克拉",
  "+E914Q": "法文（留尼翁）",
  "+FHEub": "中央阿特拉斯·塔馬澤特（阿拉伯文）",
  "/AAqs8": "葡萄牙文（赤道幾內亞）",
  "/BbMQN": "僧伽羅文",
  "/NVZFV": "葡萄牙文（安哥拉）",
  "/V7bTl": "富拉（拉丁，甘比亞）",
  "/YFnxw": "薩哈文",
  "/stiNv": "泰文",
  "019rDM": "葡萄牙文 (葡萄牙)",
  "01GXUP": "富拉（拉丁，幾內亞）",
  "0BWpf+": "日文",
  "0CHkPh": "西弗里西亞文",
  "0D82eT": "克羅埃西亞文（波士尼亞 - 黑塞哥維那）",
  "0fzUyn": "葡萄牙文",
  "0mDCSY": "西班牙文",
  "0rqbd/": "馬爾他文",
  "160k/R": "俄文",
  "1BHQDP": "孟加拉文 (印度)",
  "1F0Uz0": "阿拉伯文 (伊拉克)",
  "1J25kd": "波士尼亞文 (斯拉夫)",
  "1RqABh": "立陶宛文",
  "1dv927": "馬來文（汶萊）",
  "29JxAe": "英文 (英國)",
  "2LBIWM": "依奴提圖特文",
  "2OXQzm": "丹麥文",
  "2atqiI": "奥罗莫语",
  "2hRVBA": "塞爾維亞文",
  "30RDW+": "阿拉伯文 (卡達)",
  "3PyL86": "英文 (菲律賓)",
  "3Rvul8": "藏文（印度）",
  "3ijo+p": "荷蘭文（蘇利南）",
  "4+Zl7y": "西班牙文 (薩爾瓦多)",
  "4Od9+t": "塞爾維亞文 (斯拉夫、波士尼亞與赫塞哥維納)",
  "4U3ZpB": "法文（海地）",
  "4Xzh0/": "葡萄牙文（瑞士）",
  "4eGD8c": "富拉（拉丁，塞拉利昂）",
  "4fkP4F": "西班牙文 (古巴)",
  "4lbmZs": "西班牙文（菲律賓）",
  "4v0pnb": "威爾斯文",
  "51lnU8": "科隆方言",
  "5KynFd": "捷克文",
  "5cyBop": "英文 (印度)",
  "5ff1Qr": "特松加文",
  "5g+4ES": "韓文（朝鮮）",
  "5riLBC": "索馬里（吉布地）",
  "5vu2sQ": "烏茲別克語",
  "5xPlEp": "中文 (繁體)",
  "62eqUV": "北盧里",
  "6AZb8G": "伊努克特文（教學課程）",
  "6G/CAW": "比利時語",
  "6am43/": "中部庫德文",
  "6ebNfH": "中文（簡體，香港特別行政區）",
  "6gtes0": "中央阿特拉斯·塔馬澤特",
  "6sur5u": "丹麥文（格陵蘭）",
  "7Gt5UH": "梵文",
  "7k8oo8": "德文 (奧地利)",
  "7wLEyk": "马恩岛语",
  "7yHu97": "拉脫維亞文",
  "8MDM0L": "坦米爾文 (斯里蘭卡)",
  "8oEDHH": "法國（摩洛哥）",
  "93yDUJ": "南薩米（挪威）",
  "9cbhiA": "阿拉伯文（世界）",
  "9ftsGr": "英文 (馬來西亞)",
  "9ltErv": "罗曼什语",
  "9uEO2O": "阿圖里亞文",
  AAf440: "塞索托薩·萊博亞",
  ALhR5U: "蓋楚瓦文 (秘魯)",
  "AQfg7+": "法國剛果（金）",
  AahSYM: "烏茲別克文（阿拉伯文）",
  AeHTyT: "英文（香港特別行政區）",
  "B+59h1": "蒙古文（蒙古文）",
  B8qZTI: "亞美尼亞文",
  B9ZGRE: "寮文",
  BFf5tN: "法文 (加拿大)",
  BgGwdt: "越南文",
  BpUgM5: "荷蘭文（博奈爾、聖尤斯塔修斯和薩巴）",
  BtqqJK: "西班牙文 (宏都拉斯)",
  CBhHg6: "富拉（拉丁，奈及利亞）",
  CDbpEz: "冰島文",
  CFRfr5: "宗卡",
  CauPny: "加泰隆尼亞文（法國）",
  Ccf8zA: "西班牙文 (烏拉圭)",
  DBHTS0: "英文 (澳大利亞)",
  DMjlMC: "德文（比利時）",
  DW0c2K: "西班牙文 (智利)",
  DzWKvp: "喬治亞文",
  "EP6mL+": "曼尼普尔语",
  EREJay: "薩米（盧爾）",
  EeOqFb: "葡萄牙文（聖托梅和普林西比）",
  EzFn0W: "荷蘭文（阿路巴）",
  F38yZH: "索馬里",
  "FHLC+T": "德文 (列支敦斯登)",
  Fxzz1N: "瑞典文 (芬蘭)",
  FzgpJw: "孟加拉文",
  G7wzBO: "阿拉伯文 (阿拉伯聯合大公國)",
  "GF/5qr": "塔切爾希特",
  GGLJ5z: "科西坎",
  GHtHh4: "毛利文",
  "GRMM/R": "亞爾薩斯語 (法國)",
  "GZ+vSv": "敘利亞文",
  GnC74O: "藏文",
  GqQl0h: "義大利文",
  GsOiFJ: "英文 (南非)",
  Gwyv4n: "旁遮普文",
  "H/OHWA": "菲律賓文",
  H4fFDA: "北薩米文",
  H73FDV: "維吾爾文",
  "H7jT/h": "阿爾巴尼亞文（科索沃）",
  HDDkEc: "祖鲁语",
  HVCuT9: "英文（德國）",
  HZPa57: "蘇格蘭蓋爾文",
  "Hhe/Ef": "西班牙文（巴西）",
  Hj8GDj: "古吉拉特文",
  Hq92CJ: "夏威夷",
  HqCNsI: "挪威文",
  "I/+zqv": "英文（根西）",
  I42yCw: "英文 (加拿大)",
  IC7HXP: "提格利尼亞文",
  IDCrtf: "芬蘭文",
  IEUJ0j: "德文 (盧森堡)",
  "IR/BFt": "索馬里（衣索比亞）",
  ItGyiB: "坎那達文",
  Iz1WLp: "烏都文",
  J1rnrw: "斯洛維尼亞文",
  J5rPWm: "西班牙文 (厄瓜多)",
  JPFRXM: "英文（馬爾他）",
  JVK3dg: "德文",
  JkretN: "英文（芬蘭）",
  Js4yYb: "富拉",
  "Jsem/p": "莫霍克",
  KDsjWJ: "標準摩洛哥塔馬塞特",
  "Kj/zcq": "法文 (摩納哥)",
  LX0RZR: "富拉（阿德拉姆）",
  Laghvq: "基尼阿万达语",
  Ll0N3I: "切 諾 基",
  MESBkg: "科萨语",
  MJQbru: "巴什喀爾文",
  Mbp9v6: "阿拉伯文 (敘利亞)",
  Mt9Ngn: "希伯来语",
  N4oAho: "索托",
  NLZIcM: "荷蘭文 (比利時)",
  NObQUE: "南非荷蘭文",
  "NV+8r2": "马普切语",
  NVQG0j: "迪維西文",
  Nevbjx: "富拉（拉丁，茅利塔尼亞）",
  NfTD2i: "西班牙文 (委內瑞拉)",
  NhbCYP: "瓦倫西亞（西班牙）",
  NtuQMz: "葡萄牙文（澳門特別行政區）",
  "O/Bw0H": "塞爾維亞文（拉丁，科索沃）",
  OKUlj2: "匈牙利文",
  OSMagZ: "法文",
  Oju9iC: "蒙古文",
  P23feN: "西班牙文（貝里斯）",
  "P91ei/": "塔吉克",
  PE6jNM: "西班牙文 (阿根廷)",
  PO8fNg: "葡萄牙文（東帝汶）",
  POQTzM: "法文（塞內加爾）",
  PSoXmh: "歐迪亞文",
  Pa7aMt: "阿拉伯文 (黎巴嫩)",
  Pl3tfG: "瑞典文",
  PsNb95: "愛爾蘭文",
  Q8eBZk: "荷蘭文",
  QBwWZp: "奧羅莫（肯亞）",
  Qcitp4: "爪 哇",
  Ql51WU: "馬拉地文",
  R1VwTR: "巴斯克文",
  R325ks: "西班牙文（拉丁美洲）",
  R34HBa: "阿拉伯文 (阿曼)",
  RRmxSU: "克丘亞語",
  RTbzBi: "上索布文",
  RWrQ2K: "阿拉伯文 (阿爾及利亞)",
  "RqsM+G": "西班牙文 (尼加拉瓜)",
  SUF5bX: "英文（奧地利）",
  Sg9DRE: "法文 (瑞士)",
  SlWjJ2: "薩米（南方）",
  T9IHrN: "盧森堡文",
  TQ7V9A: "阿拉伯文 (摩洛哥)",
  Tddnlb: "泰盧固文",
  Tq0aui: "高棉文",
  UAHDtf: "馬來亞拉姆文",
  UGFi6Q: "阿拉伯文 (約旦)",
  Uc1vOK: "阿爾巴尼亞文",
  "V+BaHn": "普什圖文",
  V223G2: "富拉（拉丁，布吉納法索）",
  V2uMRt: "坦米爾文",
  VJbQAt: "西班牙文 (巴拿馬)",
  VKt1qn: "尼泊爾文（印度）",
  VuQRaN: "義大利文 (瑞士)",
  W6zXNX: "西班牙文 (多明尼加)",
  WK7YIm: "阿拉伯文 (葉門)",
  WQtbS0: "英語",
  WU7Urn: "土耳其文",
  WUUTG8: "土庫曼",
  Wlr6BV: "加泰隆尼亞 （義大利）",
  XAmFMw: "克羅埃西亞文",
  XNXAkr: "蓋楚瓦文 (厄瓜多)",
  XT8v2Z: "加泰蘭文",
  XjbxJQ: "南非人（納米比亞）",
  Xkmde4: "中文（簡體、澳門特別行政區）",
  Xx527p: "薩米，北方（瑞典）",
  Y7CQhy: "瑞士德文",
  Y8mZTh: "英文 (牙買加)",
  Y941O5: "斯洛伐克文",
  YNjb1t: "法羅語",
  Ygp3rn: "波士尼亞文",
  "Z/MVyq": "教堂斯拉維奇",
  ZCh9e6: "下索比安",
  ZQtURc: "羅馬尼亞文（摩爾多瓦）",
  ZjrmiJ: "绍纳语",
  "Zki/XJ": "哈薩克文",
  a9U6ge: "康沃爾",
  aO94Wj: "烏都文 (印度)",
  "aTZE+x": "克什米里（德瓦納加里）",
  aiXFTk: "富拉（拉丁，迦納）",
  bDNNJp: "馬來語 （印尼）",
  bLqBa4: "英文 (紐西蘭)",
  bRIPjy: "英文（以色列）",
  "bT+IsS": "馬來文（新加坡）",
  bVuD3F: "阿拉伯文",
  bfp8tQ: "格陵兰语",
  c3rP5p: "英文（斯洛維尼亞）",
  cJbw13: "中文 (繁體，台灣)",
  cQRIur: "英文 (新加坡)",
  d5MtIX: "印尼文",
  dEIOuD: "波蘭文",
  dPzT2w: "布列塔尼",
  drEx3O: "斯瓦希里语",
  e9Fovw: "帕皮亞門托",
  eGmwHh: "英文（瑞士）",
  eSg76K: "英文（直布羅陀）",
  eSmbEf: "愛爾蘭文（英國）",
  eWnJnC: "印度文",
  efy66J: "車臣",
  "f+NB92": "西班牙文 (秘魯)",
  "f/8iNS": "富拉（拉丁，喀麥隆）",
  "f5+iem": "西班牙文 (墨西哥)",
  f6Viji: "普什托（巴基斯坦）",
  fkHabQ: "基切语",
  fv9aDa: "薩米（伊納里）",
  "gHco+M": "俄羅斯（摩爾多瓦）",
  gOsLMk: "馬達加斯加文",
  gWx9ey: "塞爾維亞文（拉丁，黑山）",
  gfmlPE: "英文 (愛爾蘭)",
  glnMAY: "塔切爾希特 （拉丁）",
  gvaI7A: "索馬里（肯亞）",
  "h6q+Tn": "普魯士",
  h9YX8r: "坦米爾文 (新加坡)",
  "hEPDg/": "奥克语",
  hNSwvJ: "富拉（拉丁，賴比瑞亞）",
  hcX72z: "坦米爾文 (馬來西亞)",
  hmzrxz: "北薩米（芬蘭）",
  hr7Bt0: "葡萄牙文（幾內亞）",
  i4jvwu: "中文",
  "i5/TH8": "西班牙文 (赤道幾內亞)",
  "iI431+": "英文（荷蘭）",
  iKxsEO: "尼泊爾文",
  iTiaM1: "瓜拉尼",
  iXn58z: "亞塞拜然（斯拉夫）",
  ifdXl3: "韓文",
  jG6ZfL: "德文（義大利）",
  jGXHMX: "塞爾維亞文（拉丁，波士尼亞- 黑塞哥維那）",
  "jHvE/3": "恩科语",
  joVZ4M: "阿拉伯文 (埃及)",
  "k+bU6l": "荷蘭文（聖馬滕）",
  k6RCbu: "葡萄牙文（盧森堡）",
  kW1ixl: "基斯瓦希利（烏干達）",
  l8f1rC: "喀什米爾",
  lGAoQJ: "基斯瓦希利（坦尚尼亞）",
  "lig/ia": "博多语",
  lwerC3: "西班牙文 (美國)",
  "m+zQs1": "伊博",
  m421XM: "烏克蘭文",
  "mP+2ZR": "英文（特立尼達和多巴哥）",
  mQ30Fl: "英文（福克蘭群島）",
  mQPNAb: "辛蒂",
  mgFsmM: "英文（丹麥）",
  "mkyn/R": "阿拉伯文 (巴林)",
  mq4oU3: "英文（澤西）",
  mvxq4r: "加利西亞文",
  n86rIs: "吉爾吉斯文",
  naThLg: "希臘文",
  ncJAOw: "緬甸",
  nfKkEe: "富拉（拉丁，尼日爾）",
  nzfKPJ: "法文（喀麥隆）",
  "oCgi+u": "阿姆哈拉文",
  "oh7xe+": "薩米，盧爾（挪威）",
  oiHWuC: "德文 (瑞士)",
  ono6Zw: "西班牙文 (瓜地馬拉)",
  ouSGKF: "薩米（斯科爾特）",
  pJE11U: "塞茲瓦納（波札那）",
  pVxDdM: "馬讚達尼",
  pcWfuB: "塞茨瓦纳语",
  pdfcvu: "法國（象牙海岸）",
  pjF6Nn: "索托托（賴索托）",
  pqIrOS: "阿拉伯文 (突尼西亞)",
  q2N4yn: "塞爾維亞文 (斯拉夫)",
  qQDW8M: "法文（馬里）",
  qRbMrx: "约鲁巴语",
  qYdUNv: "中央阿特拉斯·塔馬澤特（蒂維納）",
  qu9gJ5: "阿拉伯文 (利比亞)",
  qwSYAN: "葡萄牙文（莫三比克）",
  r8ZWqf: "耐諾斯克挪威文",
  rcixhA: "荷蘭文（古拉梳）",
  rcmyN3: "波斯文（阿富汗）",
  rk5DA1: "英文（比利時）",
  sBC8AY: "辛蒂（德瓦納加里）",
  sHbxv8: "英文 (貝里斯)",
  sRuB7H: "馬來文",
  sl0qaQ: "阿拉伯文 (科威特)",
  sliV2n: "西班牙文 (巴拉圭)",
  syMU2g: "法文 (比利時)",
  tQJpug: "加泰隆尼亞文（薩摩亞）",
  tQi27b: "孔卡尼语",
  tRgqyZ: "塞爾維亞文（斯拉夫，科索沃）",
  tdrfAE: "英文 (加勒比海)",
  u0KReQ: "義大利文（梵蒂岡城）",
  u61cWR: "西班牙文 (哥倫比亞)",
  u78bW4: "馬其頓文",
  uCI04p: "愛沙尼亞文",
  uVRPPZ: "韃靼文",
  ubfX8q: "英文 (辛巴威)",
  uh1OQN: "沃洛夫语",
  upv4s2: "葡萄牙文 （卡波維德）",
  vSG3D5: "西班牙文 (哥斯大黎加)",
  viRRMu: "塞爾維亞文（斯拉夫，黑山）",
  vo99Cy: "英文（蒲隆地）",
  vuf8EY: "英文（英屬維爾京群島）",
  vxR1y4: "豪薩",
  wVqnrV: "波斯文",
  wra0CG: "基斯瓦希利（剛果））",
  wtZRFn: "弗里利亞文",
  x0KMJr: "英文（曼島）",
  xXkK79: "蒙古文（蒙古傳統蒙古文）",
  xeXtGt: "英文（瑞典）",
  xgB0JY: "阿薩姆文",
  xoMuR7: "瓦尔瑟语",
  "xzWaZ/": "西班牙文 (波多黎各)",
  "y//NHV": "亞塞拜然文",
  y7nOlh: "保加利亞文",
  ydTOo2: "法文 (盧森堡)",
  z0tSbC: "奥塞梯语",
  z1VBi8: "羅馬尼亞文",
  zBWf5p: "国际语",
  zWU1xI: "西班牙文 (玻利維亞)",
  "/+bsEl": "美洲/蒙特雷",
  "/Gtqfz": "美洲/梅里达",
  "22S38U": "美洲/阿蒂科坎",
  "3TyuhP": "美洲/奥希纳加",
  "3nz5UA": "非洲/阿比让",
  "5LGVs8": "美洲/伊努维克",
  "5hwp3A": "美洲/温尼伯",
  "75rZvt": "美洲/纳尔逊堡",
  B1cpxi: "美洲/巴伊亚班德拉斯",
  DB1i32: "美洲/奇瓦瓦",
  EjYbG7: "大西洋/加那利",
  JJlhYG: "美洲/蒙克顿",
  JK7opY: "美洲/雷尼河",
  JMiQE7: "美洲/斯威夫特卡伦特",
  JNgj9q: "美洲/温哥华",
  LQs9br: "美洲/克雷斯顿",
  TV0vfT: "美洲/埃莫西约",
  TtsBNI: "美洲/圣伊莎贝尔",
  "V/ychw": "美洲/圣约翰",
  V3RDY8: "美洲/剑桥湾",
  WrrSc3: "欧洲/马德里",
  XAJf4I: "美洲/黄色刀",
  Xf2rFn: "美洲/马萨特兰",
  "YIziP+": "美洲/兰金因莱特",
  Zw6GOE: "美洲/里贾纳",
  cvhrwM: "美洲/庞纳唐",
  d4TeTf: "美洲/怀特霍斯",
  dS4Q9B: "美洲/埃德蒙顿",
  dXgU6w: "美洲/马塔莫罗斯",
  damxMJ: "美洲/尼皮贡",
  hrTtyK: "美洲/道森克里克",
  i7y8PO: "非洲/休达",
  mYnwj6: "美洲/伊魁特",
  mZSYZK: "美洲/坎昆",
  n4UQqL: "美洲/道森",
  pIep8S: "美洲/墨西哥城",
  pZHBxH: "美洲/雷索卢特",
  puzgCP: "美洲/多伦多",
  sf6FE5: "美洲/格莱斯贝",
  trLh1J: "美洲/蒂华纳",
  vmXV5r: "美洲/布兰克-萨布隆",
  x062Q4: "美洲/哈利法克斯",
  x5t5ol: "美洲/桑德贝",
  x8MKpa: "美洲/鹅湾"
};
